// extracted by mini-css-extract-plugin
module.exports = {"Input":"Input_Input__2Y81f","Label":"Input_Label__motQ7","InputElement":"Input_InputElement__39ZDm","Invalid":"Input_Invalid__2cGdQ"};